module.exports = __webpack_public_path__ + "img/favicon.eca87de7.png";